import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { ErrorRoutingModule } from './error-routing.module';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';

@NgModule({
  declarations: [
    NotFoundPageComponent
  ],
  imports: [
    ErrorRoutingModule,
    SharedModule
  ]
})
export class ErrorModule { }
